import { render, staticRenderFns } from "./HtmlTemplate.vue?vue&type=template&id=b387797a"
import script from "./HtmlTemplate.vue?vue&type=script&lang=js"
export * from "./HtmlTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports